import { useQuery } from '@tanstack/react-query';
import { neoExecutionsCountsQueryOptions } from './neo-executions-count';

type ExecutionStateDistribution = {
  completed: number;
  failed: number;
  running: number;
  aborted: number;
  blocked: number;
  stopped: number;
  pending: number;
};

export function useExecutionStateDistribution(applicationId: string) {
  return useQuery({
    ...neoExecutionsCountsQueryOptions(applicationId),
    select: ({ byStatus }): ExecutionStateDistribution => ({
      completed: byStatus?.COMPLETED ?? 0,
      failed: byStatus?.FAILED ?? 0,
      running: byStatus?.RUNNING ?? 0,
      aborted: byStatus?.ABORTED ?? 0,
      blocked: byStatus?.BLOCKED ?? 0,
      stopped: byStatus?.PAUSED ?? 0,
      pending: 0,
    }),
    enabled: !!applicationId,
  });
}
